import VueRouter from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: {
      title: 'Главная'
    }
  },
  {
    path: '/news',
    name: 'News',
    component: () => import(/* webpackChunkName: "news" */ '../views/News.vue'),
    meta: {
      title: 'Новости'
    }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import(/* webpackChunkName: "news_detail" */ '../views/NewsDetail.vue'),
    props: true
  },
  {
    path: '/articles',
    name: 'Articles',
    component: () => import(/* webpackChunkName: "articles" */ '../views/Articles.vue'),
    meta: {
      title: 'Статьи'
    }
  },
  {
    path: '/articles/sections/:id',
    name: 'ArticlesSection',
    component: () => import(/* webpackChunkName: "articles_detail" */ '../views/ArticlesSection.vue'),
    props: true
  },
  {
    path: '/articles/:id',
    name: 'ArticleDetail',
    component: () => import(/* webpackChunkName: "articles_detail" */ '../views/ArticleDetail.vue'),
    props: true
  },
  {
    path: '/seminars',
    name: 'Seminars',
    component: () => import(/* webpackChunkName: "seminars" */ '../views/Seminars.vue'),
    meta: {
      title: 'Конференции и вебинары'
    }
  },
  {
    path: '/seminars/:id',
    name: 'SeminarDetail',
    component: () => import(/* webpackChunkName: "seminars_detail" */ '../views/SeminarDetail.vue'),
    props: true
  },
  {
    path: '/stocks/:stockId',
    name: 'StockDetail',
    component: () => import(/* webpackChunkName: "stock_detail" */ '../views/StockDetail.vue'),
    props: true
  },
  {
    path: '/special-offer',
    name: 'SpecialOffer',
    component: () => import(/* webpackChunkName: "special_offer" */ '../views/SpecialOffer.vue'),
    meta: {
      title: 'Мои спецпредложения'
    }
  },
  {
    path: '/privilege-program',
    name: 'PrivilegeProgram',
    component: () => import(/* webpackChunkName: "privilege_program" */ '../views/PrivilegeProgram.vue'),
    meta: {
      title: 'Программа привилегий'
    }
  },
  {
    path: '/privilege-program/rules',
    name: 'PrivilegeProgramRules',
    component: () => import(/* webpackChunkName: "privilege_program_rules" */ '../views/privilege-program/Rules.vue'),
    meta: {
      title: 'Правила программы'
    }
  },
  {
    path: '/faq',
    name: 'Faq',
    component: () => import(/* webpackChunkName: "faq" */ '../views/Faq.vue'),
    meta: {
      title: 'FAQ'
    }
  },
  {
    path: '/faq/cheapseo',
    name: 'FaqCheapseo',
    component: () => import(/* webpackChunkName: "faq-cheapseo" */ '../views/faq/Cheapseo.vue'),
    meta: {
      title: 'SEO-продвижение быстро и дешево? Будьте осторожны!'
    }
  },
  {
    path: '/faq/personaldata',
    name: 'FaqPersonalData',
    component: () => import(/* webpackChunkName: "faq-personaldata" */ '../views/faq/PersonalData.vue'),
    meta: {
      title: 'Владельцам сайтов: изменения в Законе «О персональных данных»'
    }
  },
  {
    path: '/faq/aboutseotext',
    name: 'FaqAboutSeoText',
    component: () => import(/* webpackChunkName: "faq-aboutseotext" */ '../views/faq/AboutSeoText.vue'),
    meta: {
      title: 'Памятка по работе с seo-текстами для клиента Demis Group'
    }
  },
  {
    path: '/faq/howtowork',
    name: 'FaqHowToWork',
    component: () => import(/* webpackChunkName: "faq-howtowork" */ '../views/faq/HowToWork.vue'),
    meta: {
      title: 'Информация по работе с данным сервисом'
    }
  },
  {
    path: '/faq/aboutdemis',
    name: 'FaqAboutDemis',
    component: () => import(/* webpackChunkName: "faq-aboutdemis" */ '../views/faq/AboutDemis.vue'),
    meta: {
      title: 'Памятка клиенту по работе с компанией Demis Group'
    }
  },
  {
    path: '/faq/stopsmoking',
    name: 'FaqStopSmoking',
    component: () => import(/* webpackChunkName: "faq-stopsmoking" */ '../views/faq/StopSmoking'),
    meta: {
      title: 'Информация о социальном проекте Demis Group'
    }
  }
]

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'active'
})
